import { useEffect, useRef, useState} from "react";
import { Tag } from "../tag/Tag";
import "./dropdown.css"
import { Icon } from "../icon";

interface DropdownProps {
    className?: string;
    label: string;
    inputLabel?: string;
    options: any[];
    value: string;
    onChange: (value: string) => void;
    renderLabel?: (option: string) => string;
    variant?: "primary" | "secondary"
}

export function Dropdown({className, inputLabel, label, options, value, variant="primary", onChange, renderLabel}: DropdownProps){
    
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {

        const handleClickOutside = (event: MouseEvent) => {
            if (
                ref.current &&
                !ref.current.contains(event.target as Node)
            ) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);

        return () =>
            document.removeEventListener("mousedown", handleClickOutside);

    }, []);

    return <div
    className={`${className} category-dropdown`}
    onClick={(e) => e.preventDefault()}
    ref={ref}
    >
        <div> 
            <div className="dropdown-input-label">   
            {inputLabel}
            </div>  
            <button
                className="dropdown-trigger"
                onClick={() => setOpen(!open)}
            >
                <Tag label={label} icon={"chevron-down"} variant={variant}></Tag>
            </button>
            {open && (
                <div className="dropdown-menu" >
                {options.map(option => (
                    <button
                        key={option}
                        className={`dropdown-item ${
                            option === value ? "selected" : ""
                        }`}
                        onClick={() => {
                            onChange(option);
                            setOpen(false);
                        }}
                    >
                    <span>{renderLabel ? renderLabel(option) : option}</span>
                    {option === value && (
                        <Icon
                            name="check"
                            size="small"
                        />
                        )}
                    </button>
                ))}
                </div>
            )}
        </div>
    </div>
};